"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _propTypes = require("prop-types");
var _theme2 = _interopRequireDefault(require("./theme"));
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function Box(_ref) {
  var children = _ref.children,
    height = _ref.height,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'primary' : _ref$type;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.ThemeProvider, {
    theme: function theme(_theme) {
      return (0, _theme2["default"])(type, _theme);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Wrapper, {
      height: height,
      children: children
    })
  });
}
Box.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.element]).isRequired,
  height: _propTypes.number.isRequired,
  type: _propTypes.string
};
var _default = exports["default"] = Box;